// extracted by mini-css-extract-plugin
export default {"imgContain":"LG","content":"MG","titleAndImage":"NG","title":"OG","text":"PG","rhodeTitle":"QG","shortHR":"RG","modal_root":"SG","x_mark":"TG","flavorStickModal":"UG","greenBox":"VG"};
    if(module.hot) {
      // 1711717533680
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  